import { validateAndTrimString } from 'core-lib/utils/utils';
import {
  BODY_TYPE_FILTERS,
  LeadType,
  ListingChips,
  MIN_REQUIRED_FIELD,
} from '../constants';
import { ListType, UserDetailsType } from '../types';

export const formatAmount = (value) => {
  if (!value || isNaN(value)) {
    return value;
  }

  if (value >= 10000000) {
    return (value / 10000000).toFixed(2) + ' Crores';
  } else if (value >= 100000) {
    return (value / 100000).toFixed(2) + ' Lakhs';
  }
  return;
};

export const getFilterText = (parsedFilters) => {
  const obj: any = {};
  if (parsedFilters?.body_type) {
    const text =
      BODY_TYPE_FILTERS.find((item) => item?.value === parsedFilters?.body_type)
        .label || '';
    if (text) {
      obj.body_type = text;
    }
  }
  if (parsedFilters?.brand_id?.length > 0) {
    obj.brand_id = `Brand (${parsedFilters?.brand_id?.length})`;
  }
  if (parsedFilters?.price?.lte && parsedFilters?.price?.gte) {
    obj.price = `${formatAmount(parsedFilters?.price?.gte)} - ${formatAmount(
      parsedFilters?.price?.lte
    )} `;
  } else if (parsedFilters?.price?.gte) {
    obj.price = `Above ${formatAmount(parsedFilters?.price?.gte)}`;
  } else if (parsedFilters?.price?.lte) {
    obj.price = `Under ${formatAmount(parsedFilters?.price?.lte)}`;
  }
  return obj;
};

export const getLabel = (filtersText, idx) => {
  switch (idx) {
    case 0:
      if (filtersText?.body_type) {
        return filtersText?.body_type;
      } else {
        return ListingChips[idx];
      }
    case 1:
      if (filtersText?.price) {
        return filtersText?.price;
      } else {
        return ListingChips[idx];
      }
    case 2:
      if (filtersText?.brand_id) {
        return filtersText?.brand_id;
      } else {
        return ListingChips[idx];
      }
    default:
      return '';
  }
};

export const checkSelected = (idx, filtersText) => {
  switch (idx) {
    case 0:
      if (filtersText?.body_type) {
        return true;
      } else {
        return false;
      }
    case 1:
      if (filtersText?.price) {
        return true;
      } else {
        return false;
      }
    case 2:
      if (filtersText?.brand_id) {
        return true;
      } else {
        return false;
      }
    default:
      return false;
  }
};

export const getShortName = (firstName, lastName) => {
  return `${firstName?.[0] || ''}${lastName?.[0] || ''}`;
};

export const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const getBodyTypeImages = (bodyType) => {
  if (!bodyType) return null;
  if (bodyType === 'suv') {
    return 'https://parkplus-bkt-img.parkplus.io/production/vehicle/public/shop_20231207115536369895.png';
  } else if (bodyType === 'hatchback') {
    return 'https://parkplus-bkt-img.parkplus.io/production/vehicle/public/shop_20231207115305742163.png';
  } else if (bodyType === 'luxury') {
    return 'https://parkplus-bkt-img.parkplus.io/production/vehicle/public/shop_20231207115505460155.png';
  } else if (bodyType === 'sedan') {
    return 'https://parkplus-bkt-img.parkplus.io/production/vehicle/public/shop_20231207115359949375.png';
  }
  return '';
};

export const checkIfAllUserDetailsExist = ({
  list = [],
  data = null,
  address,
  userDetails,
  formDetails = null,
}: {
  list?: ListType[];
  data?: ListType;
  address: any;
  userDetails: UserDetailsType;
  formDetails?: {
    [key: string]: {
      input: string | number;
      err: string;
    };
  };
}) => {
  if (data) {
    if (data?.leadType === LeadType.Oem) {
      if (!address?.data || data?.metaData?.fetchDealersList) {
        return false;
      } else if (formDetails) {
        if (formDetails?.email?.input && formDetails?.name?.input) {
          return true;
        }
      }
      return Object.keys(userDetails || {}).length >= MIN_REQUIRED_FIELD.oem;
    } else {
      if (address?.data) {
        if (formDetails) {
          if (formDetails?.name?.input) {
            return true;
          }
        }
        return (
          Object.keys(userDetails || {}).length >=
          MIN_REQUIRED_FIELD.dealerWithAddress
        );
      }
      return false;
    }
  } else if (list?.length) {
    const hasOem = list?.some((item) => item?.leadType === LeadType.Oem);
    const needDealerList = list?.some(
      (item) => item?.metaData?.fetchDealersList
    );
    if (hasOem) {
      if (!address?.data || needDealerList) {
        return false;
      } else if (formDetails) {
        if (formDetails?.email?.input && formDetails?.name?.input) {
          return true;
        }
      }
      return Object.keys(userDetails || {}).length >= MIN_REQUIRED_FIELD.oem;
    } else {
      if (!address?.data) {
        return false;
      } else if (formDetails) {
        if (formDetails?.name?.input) {
          return true;
        }
      }
      return Object.keys(userDetails || {}).length >= MIN_REQUIRED_FIELD.dealer;
    }
  }
  return false;
};

export const getEmi = ({ loanAmount, interest, duration }) => {
  const totalMonths = duration * 12;
  const monthlyInterest = interest / 1200;
  let loanConstant = 1;

  for (let i = 0; i < totalMonths; i++) {
    loanConstant *= 1 + monthlyInterest;
  }

  const emiAmount =
    (loanAmount * monthlyInterest * loanConstant) / (loanConstant - 1) || 0;

  return Math.round(emiAmount);
};

export const getName = (name) => {
  const nameArr = name?.split(' ') || [];
  const arr = nameArr.filter(
    (item) => validateAndTrimString(item).trimmedStr.length !== 0
  );
  const [firstName, lastName] = arr;
  return {
    firstName,
    lastName,
  };
};